module.exports = __webpack_public_path__ + "img/5.e1f5b8f1.png";